import * as actionTypes from "./actionTypes";

class InitialState {
  constructor() {
    this.activeAttachment = null;
    this.notificationTab = false;
    this.openTab = {
      new: false,
      approved: false,
      rejected: false,
      sent: false,
      requested: false,
    };
    this.list = {
      new: [],
      approved: [],
      rejected: [],
      sent: [],
      requested: [],
    };
    this.status = {
      getAttachmentsList: {
        loading: false,
        error: null,
        success: false,
      },
      updateAttachmentStatus: {
        loading: false,
        error: null,
        success: false,
      },
    };
    this.uploadAttachmentSuccess = false;
    this.uploadAttachmentError = false;
    this.requestAttachmentSuccess = false;
    this.requestAttachmentError = false;
  }
}

export default function reducer(state = {}, action) {
  switch (action.type) {
    case actionTypes.ATTACHMENTS_INTERACTION_INIT:
      return {
        ...state,
        downloadAttachment: false,
        [action.payload.chatId]:
          state[action.payload.chatId] || new InitialState(),
      };
    case actionTypes.HANDLE_ACTIVE_ATTACHMENT:
      return {
        ...state,
        [action.payload.chatId]: {
          ...state[action.payload.chatId],
          activeAttachment: action.payload.data,
        },
      };
    case actionTypes.HANDLE_OPEN_TAB:
      return {
        ...state,
        [action.payload.chatId]: {
          ...state[action.payload.chatId],
          openTab: {
            ...state[action.payload.chatId].openTab,
            [action.payload.name]:
              !state[action.payload.chatId].openTab[action.payload.name],
          },
        },
      };

    case actionTypes.GET_ATTACHMENTS_LIST:
      return {
        ...state,
        [action.payload.chatId]: {
          ...state[action.payload.chatId],
          status: {
            ...state[action.payload.chatId].status,
            getAttachmentsList: {
              loading: true,
              error: null,
              success: false,
            },
          },
        },
      };

    case actionTypes.GET_ATTACHMENTS_LIST_SUCCESS:
      return {
        ...state,
        [action.payload.chatId]: {
          ...state[action.payload.chatId],
          list: action.payload.data.data || {},
          status: {
            ...state[action.payload.chatId].status,
            getAttachmentsList: {
              loading: false,
              error: null,
              success: true,
            },
          },
        },
      };
    case actionTypes.GET_ATTACHMENTS_LIST_FAILURE:
      return {
        ...state,
        [action.payload.chatId]: {
          ...state[action.payload.chatId],
          status: {
            ...state[action.payload.chatId].status,
            getAttachmentsList: {
              loading: false,
              error: action.payload.error,
              success: false,
            },
          },
        },
      };
    case actionTypes.RESET_ATTACHMENTS_INTERACTION: {
      const { [action.payload.chatId]: _, ...newState } = state;
      return newState;
    }
    case actionTypes.UPDATE_ATTACHMENT_STATUS:
      return {
        ...state,
        [action.payload.chatId]: {
          ...state[action.payload.chatId],
          status: {
            ...state[action.payload.chatId].status,
            updateAttachmentStatus: {
              loading: true,
              error: null,
              success: false,
            },
          },
        },
      };
    case actionTypes.UPDATE_ATTACHMENT_STATUS_SUCCESS:
      return {
        ...state,
        [action.payload.chatId]: {
          ...state[action.payload.chatId],
          notificationTab: action.payload.fileStatus === "rejected",
          status: {
            ...state[action.payload.chatId].status,
            updateAttachmentStatus: {
              loading: false,
              error: null,
              success: true,
            },
          },
        },
      };
    case actionTypes.UPDATE_ATTACHMENT_STATUS_FAILURE:
      return {
        ...state,
        [action.payload.chatId]: {
          ...state[action.payload.chatId],
          status: {
            ...state[action.payload.chatId].status,
            updateAttachmentStatus: {
              loading: false,
              error: action.payload.error,
              success: false,
            },
          },
        },
      };
    case actionTypes.UPLOAD_ATTACHMENTS:
      return {
        ...state,
        requestAttachmentLoading: true,
        message: null,
      };
    case actionTypes.UPLOAD_ATTACHMENTS_SUCCESS:
      return {
        ...state,
        uploadAttachmentSuccess: true,
        uploadAttachmentError: false,
        requestAttachmentSuccess: true,
        requestAttachmentLoading: false,
        message: action?.payload?.message ?? null,
      };
    case actionTypes.UPLOAD_ATTACHMENTS_FAILURE:
      return {
        ...state,
        uploadAttachmentSuccess: false,
        uploadAttachmentError: true,
        requestAttachmentSuccess: false,
        requestAttachmentLoading: false, 
        message: action?.payload?.message ?? null,
      };    

    case actionTypes.DOWNLOAD_ATTACHMENT_START: 
      return {
        ...state,
        downloadAttachment: true,
      }
    case actionTypes.DOWNLOAD_ATTACHMENT_END: 
    return {
      ...state,
      downloadAttachment: false
    }
    case actionTypes.RESET_MESSAGE_TOASTE:
      return {
        ...state,
        message: null,
      };
    case actionTypes.REQUEST_ATTACHMENT:
      return {
        ...state,
        message: null,
        requestAttachmentLoading: true,
      };
    case actionTypes.REQUEST_ATTACHMENT_SUCCESS:
      return {
        ...state,
        requestAttachmentSuccess: true,
        requestAttachmentError: false,
        requestAttachmentLoading: false,
        message: action?.payload?.message ?? null,
      };
    case actionTypes.REQUEST_ATTACHMENT_FAILURE:
      return {
        ...state,
        requestAttachmentSuccess: false,
        requestAttachmentError: true,           
        requestAttachmentLoading: false,
        message: action?.payload?.message ?? null,              
      };
    default:
      return state;
  }
}
